import TemplatePickerModalContent, { TemplateOption } from './TemplatePickerModalContent';

interface BehaviorObservationTemplatesModalProps {
    existingContent?: string;
    onCancel: () => void;
    onSelect: (text: string) => void;
}

const TEMPLATE_OPTIONS: TemplateOption[] = [
    {
        id: 'complete_behavior',
        title: 'Observação comportamental completa',
        description:
            'Cobre colaboração, atenção, comunicação verbal e não verbal, e conclui que o comportamento não prejudicou a avaliação.',
        text: 'Durante as sessões, o(a) paciente demonstrou compreensão adequada dos objetivos do processo avaliativo, participando de forma ativa e colaborativa. Estabeleceu interação apropriada, mantendo-se disponível e engajado(a) na realização das tarefas propostas. A atenção mostrou-se preservada, sem evidências de agitação ou distração excessiva, com ritmo de execução compatível com as demandas apresentadas. A comunicação verbal ocorreu de maneira clara e organizada, e a comunicação não verbal foi adequada, com postura corporal, expressividade e contato visual compatíveis com o contexto. Não foram observados tiques, comportamentos repetitivos ou alterações motoras ou sensoriais relevantes. O comportamento manteve-se ajustado às regras estabelecidas, sem sinais de ansiedade de desempenho ou reações desproporcionais diante de erros ou feedbacks. De modo geral, o comportamento observado não interferiu de forma significativa na condução ou nos resultados da avaliação.',
    },
    {
        id: 'objective_behavior',
        title: 'Resumo objetivo do comportamento',
        description:
            'Resume colaboração, ritmo e comunicação em poucas linhas, sem detalhar cada aspecto.',
        text: 'Durante o processo avaliativo, o(a) paciente apresentou comportamento colaborativo, com compreensão adequada das instruções propostas. O engajamento nas tarefas mostrou-se satisfatório, com ritmo de execução compatível com as demandas apresentadas. A comunicação verbal e a interação com o avaliador ocorreram de forma adequada, sem comportamentos que interferissem na condução da avaliação.',
    },
    {
        id: 'mental_state',
        title: 'Exame do estado mental',
        description:
            'Percorre consciência, orientação, linguagem, pensamento, memória, afeto, motricidade e julgamento, item por item.',
        text: 'Durante o processo avaliativo, o(a) paciente manteve-se alerta e responsivo(a), com nível de consciência preservado ao longo das sessões. Apresentou orientação adequada quanto à própria pessoa, ao espaço e ao tempo, demonstrando compreensão das instruções propostas e capacidade de acompanhar o encadeamento das atividades. A linguagem mostrou-se compreensiva e expressiva, com discurso organizado, coerente e fluente. O pensamento apresentou curso organizado, sem prejuízos observáveis na associação de ideias durante as sessões. Em relação à memória, foi capaz de evocar informações recentes relevantes no contexto da avaliação, bem como relatar fatos remotos de forma consistente. O afeto apresentou-se congruente com o conteúdo abordado, sem labilidade emocional significativa, e o comportamento manteve-se adequado ao contexto avaliativo. Observou-se motricidade preservada, com movimentos compatíveis com a faixa etária e sem interferência funcional durante as tarefas. O(a) paciente demonstrou capacidade de insight preservada e julgamento global adequado, não sendo observadas alterações do estado mental que interferissem na condução da avaliação.',
    },
];

export default function BehaviorObservationTemplatesModal({
    existingContent,
    onCancel,
    onSelect,
}: BehaviorObservationTemplatesModalProps) {
    return (
        <TemplatePickerModalContent
            title="Modelos prontos para observação"
            options={TEMPLATE_OPTIONS}
            existingContent={existingContent}
            onCancel={onCancel}
            onSelect={onSelect}
            showOptionPreview={false}
            replaceLabel="Substituir o texto atual desta seção pelo modelo selecionado."
            ctaLabel="Usar este texto"
            cancelLabel="Cancelar"
        />
    );
}
